import { InventoryOperationEdit } from 'types';
import { Api } from '../fetch';

export const inventoryOperationNet = {
  managerAdjustment: (body: InventoryOperationEdit['managerAdjustment']) =>
    Api.post<'inventoryOperation', 'managerAdjustment'>('/inventory/operation/manager-adjustment', { body }),
  purchase: (body: InventoryOperationEdit['purchase']) =>
    Api.post<'inventoryOperation', 'purchase'>('/inventory/operation/purchase', { body }),
  warehouseTransfer: (body: InventoryOperationEdit['warehouseTransfer']) =>
    Api.post<'inventoryOperation', 'warehouseTransfer'>('/inventory/operation/warehouse-transfer', { body }),
  recycle: (body: InventoryOperationEdit['recycle']) =>
    Api.post<'inventoryOperation', 'recycle'>('/inventory/operation/recycle', { body }),
  dump: (body: InventoryOperationEdit['dump']) =>
    Api.post<'inventoryOperation', 'dump'>('/inventory/operation/dump', { body }),
  sale: (body: InventoryOperationEdit['sale']) =>
    Api.post<'inventoryOperation', 'sale'>('/inventory/operation/sale', { body }),
  donation: (body: InventoryOperationEdit['donation']) =>
    Api.post<'inventoryOperation', 'donation'>('/inventory/operation/donation', { body }),
  pickup: (body: InventoryOperationEdit['pickup']) =>
    Api.post<'inventoryOperation', 'pickup'>('/inventory/operation/pickup', { body }),
  dropoff: (body: InventoryOperationEdit['dropoff']) =>
    Api.post<'inventoryOperation', 'dropoff'>('/inventory/operation/dropoff', { body }),
  bulkIntake: (body: InventoryOperationEdit['bulkIntake']) =>
    Api.post<'inventoryOperation', 'bulkIntake'>('/inventory/operation/bulk-intake', { body }),
} as const;
